import React from 'react'
import './PrivacyPolicy.css'

const PrivacyPolicy = () => {
  return (
    <div className='privacy-policy-page'>
      <div className='privacy-policy-container'>
        <h1>Privacy Policy</h1>

        <p>
          Tager's Shoppe respects the privacy of everyone who visits this website and would like to welcome you to its website. We recommend you read this Protection of Personal Information (POPI) disclaimer so that you understand our approach towards the use of your personal information. By using this website, you acknowledge that you have read and accept the following Protection of Personal Information (POPI) disclaimer. This notice explains how we obtain, use and disclose your personal information, as is required by the Protection of Personal Information Act, Act 4 of 2013 (POPI Act).
        </p>

        <p>
          At Tager's Shoppe we are committed to protecting your privacy and to ensure that your personal information is collected and used properly, lawfully and openly. Tager's Shoppe shall take all reasonable measures to protect the personal information of data subject(s) and for the purpose of this disclaimer "personal information" and "special personal information" shall be defined as detailed in the Promotion of Access to Information Act, Act 2 of 2000 ("PAIA") and the Protection of Personal Information Act, Act 4 of 2013 ("POPI").
        </p>

        <p>
          As per the POPI Act, personal information refers to information that identifies or relates specifically to you as a person or data subject, for example, your name, age, gender, identity number and your email address.
        </p>

        <h2>Definition of Personal Information</h2>

        <p>
          According to the POPI Act "personal information" means information relating to an identifiable, living natural person, and where it is applicable, an identifiable, existing juristic person.
        </p>

        <p>
          The PAIA and POPI Acts are available online at www.gov.za/documents/acts.
        </p>

        <p>
          If you do not agree with these terms, you may choose not to use our website, and you are requested not to provide any personal information through this website.
        </p>

        <h2>The Collection of Personal Information</h2>

        <p>
          We collect and process your personal information mainly to provide you with access to our services. The type of personal information we collect, will depend on the purpose for which it is collected and used. We will only collect personal information that we need for that purpose.
        </p>

        <p>We will use your personal information only for the purposes for which it is collected or agreed with you for example:</p>

        <ul>
          <li>To render resident related services and deliveries.</li>
          <li>To carry out our obligations arising from any contracts entered between you and us.</li>
          <li>To conduct criminal, credit, reference and other related reference checks.</li>
          <li>To authenticate the resident.</li>
          <li>To provide the resident with information which Tager's Shoppe believes may be of interest to the resident, such as information relating to public awareness campaigns and matters of general public interest in which Tager's Shoppe is involved or has decided to lend its support to.</li>
          <li>To contact you regarding services, provided you have given consent to do so or you have previously requested a service from us and the communication is relevant to that prior request and made within any timeframes established by applicable laws.</li>
          <li>Use your personal information to comply with legal and regulatory requirements, or when it is prescribed by law.</li>
        </ul>

        <h2>The Storage of Personal Information</h2>

        <p>All personal information collected by Tager's Shoppe will be stored as follows:</p>

        <ul>
          <li>In terms of its Protection of Personal information Policy and PAIA Manual.</li>
          <li>In a secure and safe manner according to strict safeguards to ensure its privacy and confidentiality.</li>
          <li>For no longer than is necessary to achieve the purpose for which it was collected unless further retention is required by law or contractual obligation. In order to protect personal information from accidental or malicious destruction, when we delete your personal information from our servers, we may not immediately delete residual copies from our servers or remove information from our backup systems.</li>
          <li>Otherwise reasonably required by Tager's Shoppe for lawful purposes related to its functions and activities.</li>
          <li>Retained further with the person's consent after which the information will be de-identified and disposed of as per Tager's Shoppe's Policy and information destruction practices.</li>
        </ul>

        <h2>Personal Information Security</h2>

        <p>
          Tager's Shoppe is legally obliged to provide adequate protection for the personal information we hold and to stop unauthorised access and use of personal information. We will, on an on-going basis, continue to review our security controls and related processes to ensure that your personal information is secure.
        </p>

        <p>Our security principles cover:</p>

        <ul>
          <li>Acceptable usage of personal information</li>
          <li>Access to personal information</li>
          <li>Computer and network security</li>
          <li>Governance and regulatory issues</li>
          <li>Monitoring access and usage of personal information</li>
          <li>Secure communications</li>
        </ul>

        <p>
          When we contract with third parties, we impose appropriate security, privacy and confidentiality obligations on them to ensure that personal information that we remain responsible for, is kept secure.
        </p>

        <p>
          We will ensure that anyone to whom we pass your personal information agrees to treat your information with the same level of protection as we are obliged to.
        </p>

        <h2>Sharing of Personal Information</h2>

        <p>
          Any personal information supplied to Tager's Shoppe will be treated as confidential and Tager's Shoppe will not disclose your personal information unless legally permitted thereto. No personal information will be transferred to a third party without the explicit consent of the data subject unless legally obliged thereto. By providing the personal information, the data subject agrees that Tager's Shoppe may transfer the personal information to the following people and/or organisations in pursuit of the data processing purposes set out in our Privacy and Protection of Personal Information Policy:
        </p>

        <ul>
          <li>To the divisions in Tager's Shoppe, including directors, employees, contractors, agents, auditors, legal and other professional advisors who are authorised to process your personal information.</li>
          <li>To financial and government organisations who may request your personal information from Tager's Shoppe; the provision of such personal information includes banks, governmental, judicial, regulatory and law enforcement bodies, the South African Revenue services and the National Credit Regulator.</li>
          <li>To persons employed by Tager's Shoppe to provide services on our behalf and that adhere to principles similar to Tager's Shoppe regarding the treatment of personal information.</li>
          <li>To any person to whom Tager's Shoppe cede, delegate, transfer or assign any of our rights or obligations pertaining to services provided to the person or contracts concluded with the person.</li>
          <li>To any person who acts as legal guardian, executor of an estate, curator or in a similar capacity.</li>
          <li>To any person or persons who may be permitted by applicable law or that you may consent to, including persons or entities who may request such personal information to evaluate the credit worthiness of the person.</li>
        </ul>

        <h2>Your Rights Regarding Your Personal Information</h2>

        <p>A data subject (employee, contractor, supplier and/or resident) has the following rights to his/her personal information collected, processed and stored by Tager's Shoppe:</p>

        <ul>
          <li>Right of access to the personal information collected.</li>
          <li>Right to rectify or update your personal information.</li>
          <li>The right to object at any time to the processing of the personal information in which event the consequences of the objection will be explained to the data subject.</li>
          <li>The right to request Tager's Shoppe to no longer process the personal information of the data subject should the personal information not be required for further processing or by law.</li>
        </ul>

        <p>
          We will take all reasonable steps to confirm your identity before making changes to personal information we may hold about you. We would appreciate it if you would take the necessary steps to keep your personal information accurate and up-to-date by notifying us of any changes we need to aware of.
        </p>

        <h2>Cookies Policy</h2>

        <p>We use the term "cookies" to refer to cookies and other similar technologies covered by the POPI Act on privacy in electronic communications.</p>

        <h3>What is a cookie?</h3>

        <p>
          Cookies are small data files that your browser places on your computer or device. Cookies help your browser navigate to websites and the cookies themselves cannot collect any information stored on your computer or your files. To protect your privacy, your browser only gives a website access to the cookies it has already sent to you.
        </p>

        <h3>Why do we use cookies?</h3>

        <p>
          Cookies remember the type of browser you use and which additional browser software you installed. Cookies also remember your preferences, such as language and region, which remain as your default settings when you revisit the site.
        </p>

        <h3>How do I reject and delete cookies?</h3>

        <p>
          We will not use cookies to collect personal identifiable information about you. However, should you wish to do so, you can choose to reject or block the cookies set by the websites by changing your browser settings – see "Help" function within your browser for further details. Please note most browsers automatically accept cookies so if you do not wish cookies to be used you may need to actively delete or block the cookies. If you reject the use of cookies, you will still be able to visit our website but some functions may not work correctly.
        </p>

        <h2>General Conditions Pertaining To Personal Information</h2>

        <p>
          Tager's Shoppe accepts no liability whatsoever for any loss, damage (whether direct, indirect, special or consequential) and/or expenses of any nature whatsoever which may arise as a result of, or which may be attributable directly or indirectly from personal information made available on these pages or links, or actions or transaction resulting there from.
        </p>

        <p>
          The Laws of the Republic of South Africa will govern all terms and conditions of any services contained in these pages. Should you request services through the Tager's Shoppe website you hereby consent and submit to the jurisdiction of the South African courts in regard to all proceedings, actions, applications or the like instituted by each party against the other, and in any way arising from any stated terms and conditions.
        </p>
      </div>
    </div>
  )
}

export default PrivacyPolicy
